// Subtle keyboard-click sound synthesizer using Web Audio API — no assets needed.
let ctx = null;

function ensureCtx() {
  if (!ctx) {
    try { ctx = new (window.AudioContext || window.webkitAudioContext)(); } catch { return null; }
  }
  if (ctx.state === "suspended") ctx.resume();
  return ctx;
}

export function playClick() {
  const audio = ensureCtx();
  if (!audio) return;
  const now = audio.currentTime;

  // High-frequency noise burst — the "click"
  const bufSize = Math.floor(audio.sampleRate * 0.05);
  const buf = audio.createBuffer(1, bufSize, audio.sampleRate);
  const data = buf.getChannelData(0);
  for (let i = 0; i < bufSize; i++) {
    data[i] = (Math.random() * 2 - 1) * Math.pow(1 - i / bufSize, 5);
  }
  const noise = audio.createBufferSource();
  noise.buffer = buf;
  const bandpass = audio.createBiquadFilter();
  bandpass.type = "bandpass";
  bandpass.frequency.value = 3200;
  bandpass.Q.value = 1.2;
  const noiseGain = audio.createGain();
  noiseGain.gain.setValueAtTime(0.35, now);
  noiseGain.gain.exponentialRampToValueAtTime(0.001, now + 0.045);
  noise.connect(bandpass).connect(noiseGain).connect(audio.destination);
  noise.start(now);
  noise.stop(now + 0.05);

  // Low "thock" body
  const osc = audio.createOscillator();
  osc.type = "triangle";
  osc.frequency.setValueAtTime(220, now);
  osc.frequency.exponentialRampToValueAtTime(90, now + 0.05);
  const oscGain = audio.createGain();
  oscGain.gain.setValueAtTime(0.25, now);
  oscGain.gain.exponentialRampToValueAtTime(0.001, now + 0.06);
  osc.connect(oscGain).connect(audio.destination);
  osc.start(now);
  osc.stop(now + 0.06);
}
